'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NETWORK_UP = exports.NETWORK_UP = 'PNNetworkUpCategory';
var NETWORK_DOWN = exports.NETWORK_DOWN = 'PNNetworkDownCategory';
var NETWORK_ISSUES = exports.NETWORK_ISSUES = 'PNNetworkIssuesCategory';
var RECONNECTED = exports.RECONNECTED = 'PNReconnectedCategory';
var CONNECTED = exports.CONNECTED = 'PNConnectedCategory';
var ACCESS_DENIED = exports.ACCESS_DENIED = 'PNAccessDeniedCategory';
var MALFORMED_RESPONSE = exports.MALFORMED_RESPONSE = 'PNMalformedResponseCategory';
var BAD_REQUEST = exports.BAD_REQUEST = 'PNBadRequestCategory';
var DECRYPTION_ERROR = exports.DECRYPTION_ERROR = 'PNDecryptionErrorCategory';
var TIMEOUT = exports.TIMEOUT = 'PNTimeoutCategory';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/constants/PubNubStatusCategories.js
// module id = 115
// module chunks = 0 1